import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "app/components/React/Table/cells/DomainListWithTooltip/styled";
import type { IBannerTheme } from "app/components/React/TrialBanner/StyledTrialBanner";

const CenterStyled = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;

export const BoxContainer = styled(CenterStyled)<{ $bannerTheme: IBannerTheme }>`
    width: 28px;
    padding: 2px 0px;
    flex-direction: column;
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[0]};
    ${({ $bannerTheme }) => setFontVariant("subsectionTitle", $bannerTheme.counterColor)};
    margin: 0 4px;
`;

export const Colon = styled.div`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[0])};
`;
